import { ConfigFn } from '@config/types'

const config = (({ ugcUrl }) =>
  ({
    uploadUrl: `${ugcUrl}/upload`,
  }) as const) satisfies ConfigFn

export default config
